import React from 'react';
import './Events.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const Events = ({ setCurrentPage }) => {
  const { t } = useLanguage();

  const handleContactClick = () => {
    setCurrentPage('contact');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const upcomingEvents = [
    {
      id: 1,
      titleKey: 'events.eventItems.mahashivratri.title',
      dateKey: 'events.eventItems.mahashivratri.date',
      timeKey: 'events.eventItems.mahashivratri.time',
      descKey: 'events.eventItems.mahashivratri.description',
      typeKey: 'events.eventItems.mahashivratri.type',
      icon: 'om'
    },
    {
      id: 2,
      titleKey: 'events.eventItems.annualYatra.title',
      dateKey: 'events.eventItems.annualYatra.date',
      timeKey: 'events.eventItems.annualYatra.time',
      descKey: 'events.eventItems.annualYatra.description',
      typeKey: 'events.eventItems.annualYatra.type',
      icon: 'flag'
    },
    {
      id: 3,
      titleKey: 'events.eventItems.chaitraNavratri.title',
      dateKey: 'events.eventItems.chaitraNavratri.date',
      timeKey: 'events.eventItems.chaitraNavratri.time',
      descKey: 'events.eventItems.chaitraNavratri.description',
      typeKey: 'events.eventItems.chaitraNavratri.type',
      icon: 'trident'
    },
    {
      id: 4,
      titleKey: 'events.eventItems.guruPurnima.title',
      dateKey: 'events.eventItems.guruPurnima.date',
      timeKey: 'events.eventItems.guruPurnima.time',
      descKey: 'events.eventItems.guruPurnima.description',
      typeKey: 'events.eventItems.guruPurnima.type',
      icon: 'lamp'
    },
    {
      id: 5,
      titleKey: 'events.eventItems.shravanSomvar.title',
      dateKey: 'events.eventItems.shravanSomvar.date',
      timeKey: 'events.eventItems.shravanSomvar.time',
      descKey: 'events.eventItems.shravanSomvar.description',
      typeKey: 'events.eventItems.shravanSomvar.type',
      icon: 'flower'
    },
    {
      id: 6,
      titleKey: 'events.eventItems.ganeshChaturthi.title',
      dateKey: 'events.eventItems.ganeshChaturthi.date',
      timeKey: 'events.eventItems.ganeshChaturthi.time',
      descKey: 'events.eventItems.ganeshChaturthi.description',
      typeKey: 'events.eventItems.ganeshChaturthi.type',
      icon: 'elephant'
    }
  ];

  const pastEvents = [
    {
      id: 1,
      titleKey: 'events.pastEventItems.diwali2025.title',
      dateKey: 'events.pastEventItems.diwali2025.date',
      descKey: 'events.pastEventItems.diwali2025.description',
      image: '/Assets/gallery/san_1.jpg'
    },
    {
      id: 2,
      titleKey: 'events.pastEventItems.yatra2025.title',
      dateKey: 'events.pastEventItems.yatra2025.date',
      descKey: 'events.pastEventItems.yatra2025.description',
      image: '/Assets/gallery/san_2.jpg'
    }
  ];


  return (
    <div className="events-page">
      <div className="events-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('events.pageSubtitle')}</span>
          <h1>{t('events.pageTitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>

      <div className="container">
        <section className="upcoming-section">
          <div className="section-header">
            <h2 className="section-title">{t('events.upcomingEventsTitle')}</h2>
            <div className="title-underline"></div>
          </div>

          <div className="events-list">
            {upcomingEvents.map((event) => (
              <div key={event.id} className="modern-event-card">
                <div className="card-left">
                  <div className="event-date-box">
                    <span className="event-icon-small"><Icon name={event.icon} /></span>
                    <span className="full-date">{t(event.dateKey)}</span>
                  </div>
                </div>

                <div className="card-right">
                  <div className="card-header">
                    <h3>{t(event.titleKey)}</h3>
                    <span className={`event-badge ${t(event.typeKey).toLowerCase()}`}>{t(event.typeKey)}</span>
                  </div>

                  <div className="card-meta">
                    <span className="time-info"><Icon name="clock" /> {t(event.timeKey)}</span>
                  </div>

                  <p className="card-desc">{t(event.descKey)}</p>

                  <div className="card-footer">
                    <button
                      className="learn-more-btn"
                      onClick={handleContactClick}
                    >
                      <span>{t('events.learnMore')}</span>
                      <i className="arrow-right">→</i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>


        <section className="past-memories-section">
          <div className="section-header">
            <h2 className="section-title">{t('events.pastEventsTitle')}</h2>
            <div className="title-underline"></div>
          </div>

          <div className="memories-grid">
            {pastEvents.map((event) => (
              <div key={event.id} className="memory-card">
                <div className="memory-image">
                  <img src={event.image || '/Assets/home/dev.jpg'} alt={t(event.titleKey)} />
                  <div className="image-overlay">
                    <span className="memory-date">{t(event.dateKey)}</span>
                  </div>
                </div>
                <div className="memory-content">
                  <h3>{t(event.titleKey)}</h3>
                  <p>{t(event.descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="engagement-section">
          <div className="glass-info-card">
            <div className="glass-content">
              <h3>{t('events.wantToParticipate')}</h3>
              <p>{t('events.participateText')}</p>
              <div className="action-buttons">
                <button
                  className="primary-glass-btn"
                  onClick={handleContactClick}
                >
                  {t('events.contactUs')}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Events;
